// Copyright 2016 Sorama B.V.

export abstract class IRegistrableHardwareDevice {
    public moduleId: string;
}
